export default __webpack_public_path__ + "static/Berenice-ead81699749eed464e1e2a8015ba8c0d.webp";